module.exports = __webpack_public_path__ + "img/grey-3days.7a56440f.png";